import { render, staticRenderFns } from "./EmployerOtherComissionsRadio.vue?vue&type=template&id=0493fc9f&"
import script from "./EmployerOtherComissionsRadio.vue?vue&type=script&lang=js&"
export * from "./EmployerOtherComissionsRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports